import React, { useState } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  Stack,
  Divider,
  Paper,
} from "@mui/material";
import AddReactionIcon from "@mui/icons-material/AddReaction";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PinDropIcon from "@mui/icons-material/PinDrop";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import VerifiedIcon from "@mui/icons-material/Verified";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useParams } from "react-router-dom";
import { IMAGE_URL } from "network";
import { formatDate } from "utility";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useGetSingleClinicQuery, useUnlinkClinicAreaMutation  } from "slices/wellness/clinicSlice";
import SmallMap from "../../../../utility/SmallMap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProfileEdit from "utility/profileEdit";
import ConcernEdit from "utility/concernEdit";
import Location from "utility/location";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";


function ViewClinic() {
  const { id } = useParams();
  const [del] = useUnlinkClinicAreaMutation();
  const { data: clinic, refetch } = useGetSingleClinicQuery(id);
  const [openProfile, setProfile] = useState(false);
  const [openConcerns, setConcerns] = useState(false);
  const [openLocations, setLocations] = useState(false);

  const b = clinic?.data;
  console.log("beautician", clinic);

  const setProfileClose = () => {
    refetch();
    setProfile(false);
    setConcerns(false);
    setLocations(false);
  };

  const delLocation = async (linkk) => {
    if (window.confirm("Are you sure you want delete this area?")) {
      try {
        const response = await del(linkk._id).unwrap();
        if (response) {
          refetch();
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.data?.message || error?.message || "Server error",
        });
      }
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ProfileEdit
        open={openProfile}
        data={b}
        usertype={"clinic"}
        onClose={() => setProfileClose()}
      />

      <ConcernEdit
        open={openConcerns}
        data={b}
        usertype={"clinic"}
        onClose={() => setProfileClose()}
      />
      <Location
        open={openLocations}
        data={b}
        usertype={"clinic"}
        onClose={() => setProfileClose()}
      />

      <Box px={3} py={4}>
        {/* Hero Profile Card */}
        <Card
          sx={{
            p: 4,
            borderRadius: 6,
            mb: 4,
            boxShadow: 8,
            background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
            color: "#333",
          }}
        >
          <EditIcon
            color="primary"
            sx={{ position: "absolute", top: 16, right: 16 }}
            onClick={() => setProfile(true)}
          />
          <Grid container spacing={4} alignItems="center">
            {/* Left Side - Avatar */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                <img
                  src={IMAGE_URL + b?.image}
                  alt={b?.name}
                  crossOrigin="anonymous"
                  height={"100px"}
                  width={"100px"}
                  style={{
                    borderRadius: "50%",
                    objectFit: "cover",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    border: "3px solid #fff",
                  }}
                />

                <Typography variant="subtitle1" mt={2} fontWeight="bold">
                  {b?.name}
                </Typography>
              </Box>
            </Grid>

            {/* Right Side - Details */}
            <Grid item xs={12} md={9}>
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={6}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <EmailIcon color="primary" />
                    <Typography>{b?.email}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <PhoneIcon color="secondary" />
                    <Typography>{b?.mobile}</Typography>
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CalendarTodayIcon />
                    <Typography>Started: {formatDate(b?.startUpAt)}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <VerifiedIcon
                      color={b?.status === "active" ? "success" : "error"}
                    />
                    <Typography textTransform="capitalize">
                      {b?.status}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CurrencyRupeeIcon />
                    <Typography>{b?.perMinutCharges} / session</Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 4,
              borderRadius: 6,
              mb: 4,
              boxShadow: 8,
              background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
              color: "#333",
            }}
          >
            <EditIcon
              color="primary"
              sx={{ position: "absolute", top: 16, right: 16 }}
              onClick={() => setConcerns(true)}
            />
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <AddReactionIcon color="primary" />
              <Typography variant="h6" fontWeight={600}>
                Concerns
              </Typography>
            </Stack>
            <Divider sx={{ mb: 3 }} />

            {b?.concernLinks?.length ? (
              <Grid container spacing={2}>
                {b.concernLinks.map((item, i) => (
                  <Grid item xs={12} sm={6} key={i}>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        transition: "transform 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: 8,
                        },
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={IMAGE_URL + item?.concern?.icon}
                        alt={item?.concern?.icon}
                        height="50"
                        width="50"
                        style={{
                          borderRadius: 8,
                          objectFit: "cover",
                          marginRight: 16,
                          border: "2px solid #e0e0e0",
                        }}
                        crossOrigin="anonymous"
                      />
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item?.concern?.title || `Document ${i + 1}`}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography color="text.secondary">
                No concerns added yet.
              </Typography>
            )}
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 4,
              borderRadius: 6,
              mb: 4,
              boxShadow: 8,
              background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
              color: "#333",
            }}
          >
            <AddIcon
              color="primary"
              sx={{ position: "absolute", top: 16, right: 16 }}
              onClick={() => setLocations(true)}
            />
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <PinDropIcon color="primary" />
              <Typography variant="h6" fontWeight={600}>
                Selected City and Areas
              </Typography>
            </Stack>
            {b?.areaLinks?.length ? (
              <>
                {[
                  ...new Map(
                    b.areaLinks.map((item) => [
                      item.area.city._id,
                      item.area.city,
                    ])
                  ).values(),
                ].map((city) => (
                  <Box key={city._id} mb={3}>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      color="primary"
                      mb={1}
                    >
                      {city.cityName}
                    </Typography>

                    <Slider
                      dots={true}
                      infinite={false}
                      speed={500}
                      slidesToShow={3}
                      slidesToScroll={1}
                      responsive={[
                        {
                          breakpoint: 900,
                          settings: {
                            slidesToShow: 1,
                          },
                        },
                      ]}
                    >
                      {b.areaLinks
                        .filter((link) => link.area.city._id === city._id)
                        .map((link) => {
                          const coords = [
                            link.area.location.coordinates[1],
                            link.area.location.coordinates[0],
                          ];

                          return (
                            <Box key={link._id} px={2}>
                              <Card
                                sx={{
                                  p: 2,
                                  borderRadius: 4,
                                  boxShadow: 4,
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <DeleteIcon
                                  color="primary"
                                  sx={{
                                    position: "absolute",
                                    top: 16,
                                    right: 16,
                                  }}
                                  onClick={() => delLocation(link)}
                                />
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                  mb={1}
                                >
                                  {link.area.areaName}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  mb={1}
                                >
                                  Pincode: {link.area.pincode}
                                </Typography>
                                <SmallMap coordinates={coords} />
                              </Card>
                            </Box>
                          );
                        })}
                    </Slider>
                  </Box>
                ))}
              </>
            ) : (
              <Typography color="text.secondary">
                No area data available.
              </Typography>
            )}
          </Card>
        </Grid>
      </Box>

      <Footer />
    </DashboardLayout>
  );
}

export default ViewClinic;
